import styled, { css } from 'styled-components'
import { ButtonUnstyled, Input } from '@sketch/components'
import { ReactComponent as MagGlassSvg } from '@sketch/icons/magnifying-glass-24-svg'
import { ReactComponent as CrossSvg } from '@sketch/icons/cross-circle-18-svg'
import { breakpoint } from '@sketch/global-styles'

export const iconStyles = css`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }

  &:active {
    color: ${({ theme }) => theme.colors.foreground.secondary.B};
  }
`

export const LoupeIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  z-index: 1;

  width: 24px;
  height: 24px;

  margin: auto;
`

export const LoupeIcon = styled(MagGlassSvg).attrs({
  role: 'img',
  'aria-label': 'Search',
})(
  ({ theme }) => css`
    width: 24px;
    height: 24px;

    transition: all
      ${`${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}`};

    ${iconStyles};

    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  `
)

export const ClearButton = styled(ButtonUnstyled)`
  width: 24px;
  height: 24px;
  margin: 4px 8px;
`

export const CrossIcon = styled(CrossSvg).attrs({
  role: 'img',
  'aria-label': 'Clear',
})(
  ({ theme }) => css`
    width: 16px;
    height: 16px;
    margin: 0 -3px 0 8px; /* stylelint-disable-line scales/space */
    ${iconStyles};
  `
)

export const SearchInput = styled(Input)(
  ({ theme }) => css`
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;

    ${breakpoint('sm')`
      height: 32px;
    `}

    &[type='search'] {
      font-size: ${theme.fontSizes.D};
      border-radius: ${theme.radii.large};
      border: 1px solid ${theme.colors.border.B};
      padding-left: 40px;
      padding-right: 40px;
      background: none;

      ::-webkit-search-decoration,
      ::-webkit-search-cancel-button {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -webkit-appearance: none;
        appearance: none;
      }

      &::placeholder {
        color: ${theme.colors.state.disabled};
      }
    }
  `
)

export const Form = styled.form<{ width?: number }>(
  ({ theme, width }) => css`
    width: 100%;

    transition: all
      ${`${theme.transitions.duration[2]} ${theme.transitions.timing.easeInOut}`};

    ${Input} {
      opacity: 1;
    }

    ${typeof width !== 'undefined' &&
    breakpoint('sm')`
      width: ${width}px;
    `};
  `
)

export const ClearButtonAndChildrenWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 40px;

  ${breakpoint('sm')`
    height: 32px;
  `}
`
